import {
	IPreferenceDetailsResponse,
	IEmailConsent,
	ISMSConsentResponse,
	IPaperlessConsent,
} from '@sentara-health/sentara-api-hooks-core';

export interface ProfileInformation extends IPreferenceDetailsResponse {
	memberId: string;
	isEmailValid: boolean;
	preferenceChannel: string;
	profileImage?: string;
}

export const mapProfileResponseToProfileInformations = (response: any): ProfileInformation => {
	const mapConsentStatusToBoolean = (status: string): boolean => {
		return status === 'Opt-in';
	};

	return {
		memberId: response?.identifier?.find((id: any) => id.system === 'memberId')?.value ?? '',
		firstName: response?.firstName ?? '',
		lastName: response?.lastName ?? '',
		email: response?.email?.[0]?.value ?? '',
		isEmailValid: response?.email?.[0]?.emailStatus === 'Valid',
		dob: response?.dob ?? '',
		phones:
			response?.telecom?.map((telecom: any) => ({
				phoneNumber: telecom.value,
				phoneType: telecom.use,
			})) ?? [],
		address:
			response?.address?.map((addr: any) => ({
				street: addr.address1 ?? addr.street ?? '',
				city: addr.city ?? '',
				state: addr.state ?? '',
				zipCode: addr.zip ?? addr.zipCode ?? '',
				addressType: addr.addressType ?? 'HOME',
			})) ?? [],
		languagePreference:
			response?.Preferences?.find(
				(pref: any) => pref.identifier?.[0]?.value === 'Language preference',
			)?.option ?? '',
		smsConsent: {
			mobileNumber:
				response?.telecom?.find((telecom: any) => telecom.use === 'mobile')?.value ?? '',
			optInConsent: mapConsentStatusToBoolean(
				response?.Consent?.find(
					(consent: any) =>
						consent.name === 'TCPA|SMS|SHP' &&
						consent.contactPoint?.toLowerCase() === 'preference/telecom/Mobile'.toLowerCase(),
				)?.status ?? '',
			),
			phoneType: response?.telecom?.find((telecom: any) => telecom.use === 'mobile')?.use ?? 'mobile',
			termsAndCondition:
				response?.Consent?.find(
					(consent: any) =>
						consent.name === 'TCPA|SMS|SHP' &&
						consent.contactPoint?.toLowerCase() === 'preference/telecom/Mobile'.toLowerCase(),
				)?.termsAndCondition ?? false,
		} as ISMSConsentResponse,
		emailConsent: {
			email: response?.email?.[0]?.value ?? '',
			optInConsent: mapConsentStatusToBoolean(
				response?.Consent?.find((consent: any) => consent.name === 'Email|SHP')?.status ?? '',
			),
		} as IEmailConsent,
		paperlessConsent: {
			optInConsent: mapConsentStatusToBoolean(
				response?.Consent?.find((consent: any) => consent.name === 'EOB|Paperless|SHP')?.status ??
				'',
			),
		} as IPaperlessConsent,
		isMemberEnrolled: response?.active ?? false,
		dependents: response?.dependents ?? [],
		deliveryPreferences: response?.deliveryPreferences ?? [],
		hideAccountSettings: response?.hideAccountSettings ?? false,
		correspondenceFlag: response?.correspondenceFlag ?? false,
		canChangeContactInfo: response?.canChangeContactInfo ?? false,
		profileImage: response?.profileImage?.data ?? '',
		preferenceChannel:
			response?.Preferences?.find(
				(pref: any) => pref.identifier?.[0]?.value === 'Preferred Channel',
			)?.option ?? '',
	};
};